/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspostcategory_Subtitle2Inputs */

const vi_cmspostcategory_subtitle2 = /** @type {(inputs: Cmspostcategory_Subtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyên mục của trang Tin tức trên website. Chuyên mục còn bài thì không xoá được.`)
};

/**

* @param {Cmspostcategory_Subtitle2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspostcategory_subtitle2 = /** @type {((inputs?: Cmspostcategory_Subtitle2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspostcategory_Subtitle2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspostcategory_subtitle2(inputs)
});
export { cmspostcategory_subtitle2 as "cmsPostCategory_subtitle" }